// LPガスレンタル共通アコーディオン
$(function () {
    $('.js-product-accordion').each(function () {
        const $accordion = $(this);
        const $button = $accordion.find('.js-product-accordion__btn');
        const $detail = $accordion.find('.js-product-accordion__detail');

        // 初期状態は閉じる
        $detail.hide();

        $button.attr('aria-expanded', 'false');

        // =====================================================
        // ボタンクリック
        // =====================================================
        $button.on('click', function () {
            $accordion.toggleClass('is-open');
            $detail.stop(true, true).slideToggle(300);

            // =====================================================
            // 開閉状態
            // =====================================================
            if ($accordion.hasClass('is-open')) {
                $button.text('閉じる');
                $button.attr('aria-expanded', 'true');
                $button.addClass('is-open');
            } else {
                $button.text('くわしく見る');
                $button.attr('aria-expanded', 'false');
                $button.removeClass('is-open');
            }
        });
    });
});